import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LoaderService } from '@services/loader.service';
import { PlacementService } from '@services/placement.service';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-active-odo-average-weight',
  templateUrl: './active-odo-average-weight.component.html',
  styleUrl: './active-odo-average-weight.component.scss'
})
export class ActiveOdoAverageWeightComponent {
  @Input() placementId: number | null = null;
  @Output() close: EventEmitter<void> = new EventEmitter<void>();
  odoForm: FormGroup;
  public isAuthLoading = false;
  public isLoading$: Observable<boolean>;
  @Output() dataSaved: EventEmitter<void> = new EventEmitter<void>();
  constructor(private fb: FormBuilder,
    private placementService: PlacementService,
    private toastr: ToastrService,
    private loaderService: LoaderService
  ) {}

  ngOnInit(): void {
    this.odoForm = this.fb.group({
      placementId:[this.placementId],
      weight: ['', [Validators.required, Validators.min(0)]]
    });
  }

  onSubmit(): void {
    this.loaderService.showLoader();
    this.isAuthLoading = true;
    //this.markFormGroupTouched(this.parentForm);
    this.markFormGroupTouched(this.odoForm);
    if (this.odoForm.valid) {
      const weight = this.odoForm.value;
      this.placementService.addActivePlacementODOAverageWeight(weight).subscribe({
        next: (response) => {
          setTimeout(() => {
            this.isAuthLoading = false;
            this.loaderService.hideLoader();
            this.toastr.success("ODO Vaerage Weight Added Successfully");
            this.close.emit();
          }, 2000);
        },
        error: (error) => {
          setTimeout(() => {
            this.isAuthLoading = false;
            this.loaderService.hideLoader();
            // Handle login error
            this.toastr.error("Error in Save Data!");

          }, 2000);
        }
      });
    } else {
      this.loaderService.hideLoader();
      this.isAuthLoading = false;
      this.toastr.error('Please fill the required fields');
    }
   
    
  }
  isControlInvalid(controlName: string): boolean {
    const control = this.odoForm.get(controlName);
    return control?.invalid && (control.touched || control.dirty);
  }
  private markFormGroupTouched(formGroup: FormGroup) {
    Object.values(formGroup.controls).forEach(control => {
      control.markAsTouched();

      if (control instanceof FormGroup) {
        this.markFormGroupTouched(control);
      }
    });
  }
}
